import { createSelector } from '@reduxjs/toolkit';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import isMobile from 'store/app/selector/isMobile';
import getCurrentCategory from 'store/category/selector/getCurrentCategory';
import styles from './Banner.module.scss';

const bannerData = createSelector(getCurrentCategory, (category) => category?.banner);
const bannerImage = createSelector(bannerData, isMobile, (banner, isMobileDevice) =>
  isMobileDevice ? banner?.bannerMobileImageUrl : banner?.bannerImageUrl,
);

const Banner: FC = () => {
  const data = useSelector(bannerData);
  const image = useSelector(bannerImage);

  return (
    <>
      {image && (
        <div className={styles.container}>
          <div className={styles.banner}>
            <img src={image} alt="Banner" className={styles.image} />
          </div>
          <div className={styles.textContainer}>
            <div className={styles.header}>{data?.bannerHeading}</div>
            <div className={styles.description}>{data?.bannerText}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default Banner;
